import { render, staticRenderFns } from "./User-Management.vue?vue&type=template&id=0f394172&scoped=true"
import script from "./User-Management.vue?vue&type=script&lang=js"
export * from "./User-Management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f394172",
  null
  
)

export default component.exports